import type { HotelDetailV2Model } from "../model/hotelDetailV2.model";
import { hotelContentToText } from "../utils/contentText";
import ReadMoreText from "./ReadMoreText";

export default function RulesSection({ hotel }: { hotel: HotelDetailV2Model }) {
  const rules = hotelContentToText(hotel.rulesHtml);

  return (
    <section
      id="rules"
      className="scroll-mt-28 rounded-2xl border border-[rgb(229,231,235)] bg-white p-5"
    >
      <h2 className="mb-4 text-base font-bold text-[#1a1a2e]">
        قوانین و مقررات هتل
      </h2>
      {/* TODO: Restore the primary rules and free services blocks after they are wired to real hotel data. */}
      {rules ? (
        <div>
          <ReadMoreText text={rules} collapsedClassName="line-clamp-4" />
        </div>
      ) : null}
    </section>
  );
}
